import * as React from 'react';
import * as PropTypes from 'prop-types'
import * as ct from '../../../global/controls';
import * as v from '../../../global/validation';
import moment from 'moment';
import { ProdVariant } from './types';
import { DateFormat } from '../../../../store/pages/venues/types';
import { formHandler, clickHandler, isNullOrEmpty } from '../../../../utils/util';
import { validateVariantAvailableFrom, validateVariantAvailableTo, validateVariantDescription, validateVariantName } from "./variantValidations";
import Dropzone from "react-dropzone";
import { getImageProps, ImageFile } from "../../../../utils/images";

interface ProductVariantFormProps {
    variant: ProdVariant;
    dateFormat: DateFormat;
    saveChanges: (key: string, variant: ProdVariant) => void;
    close: () => void;
}

interface ProductVariantFormState {
    isNew: boolean;
    name: ct.FormValue<string>;
    description: ct.FormValue<string>;
    availableFrom: ct.FormValue<moment.Moment>;
    availableTo: ct.FormValue<moment.Moment | null>;

    productVariantImageUrl: string | null;
    productVariantImage: ImageFile | null;
    imageError: string | null;
}

class ProductVariantForm extends React.Component<ProductVariantFormProps, ProductVariantFormState> {

    constructor(props: ProductVariantFormProps) {
        super(props);

        this.state = this.buildStateFromProps(this.props);
    }

    static contextTypes = {
        t: PropTypes.func
    }

    private buildStateFromProps(props: ProductVariantFormProps): ProductVariantFormState {
        const { variant } = props;
        const { id, name, description, availableFrom, availableTo } = variant;
        const isNew = !(variant && id);

        return {
            isNew: isNew,
            name: name,
            description: description,
            availableFrom: availableFrom,
            availableTo: availableTo,
            productVariantImageUrl: (isNew || !variant) ? null : variant.productVariantImageUrl,
            productVariantImage: null,
            imageError: null,
        }
    }

    onImageDrop = (files: File[]) => {
        const { t } = this.context;
        const file = files[0];

        getImageProps(file).then(img => {
            if (img.width !== 160 || img.height !== 160) {
                this.setState({ imageError: t('Global:imageWrongSize', { w: 160, h: 160 }) });
            } else {
                this.setState({ 
                    imageError: null, 
                    productVariantImage: { file: file, preview: URL.createObjectURL(file) },
                    productVariantImageUrl: URL.createObjectURL(file)
                });
            }
        });
    }

    save = () => {
        if (!v.isValid(this.state)) {
            // TODO: Show error message!
        } else {
            const { name, description, availableFrom, availableTo, productVariantImage, productVariantImageUrl } = this.state;
            const { variant } = this.props;
            this.props.saveChanges(variant.key, {
                ...variant,
                name: name,
                description: description,
                availableFrom: availableFrom,
                availableTo: availableTo,
                productVariantImage: productVariantImage,
                productVariantImageUrl: productVariantImageUrl
            })
        }
    }

    render() {
        const { t } = this.context;
        const { variant, dateFormat, close } = this.props;
        const { isNew, name, description, availableFrom, availableTo, productVariantImageUrl, productVariantImage, imageError } = this.state;

        let previewImg: JSX.Element | null = null;
        const imageUrl = productVariantImage ? productVariantImage.preview : productVariantImageUrl !== null ? productVariantImageUrl : null;
        if (imageUrl) {
            previewImg = <img src={imageUrl} className='file-preview' alt='preview' style={({ width: '100px' })}></img>;
        }

        return <div>
            <h2>{isNew ? t('ProductVariantForm:addHeading') : t('ProductVariantForm:editHeading')}</h2>

            <form className='data-form' onSubmit={e => formHandler(e)} autoComplete='off'>
                <div className='row'>
                    <div className='col-xs-12'>
                        <ct.TextBox id={`${variant.key}_name`} labelKey='ProductVariant:name' value={name} callback={val => this.setState(s => ({ name: val ? validateVariantName(val, []) : s.name }))} />
                    </div>
                    <div className='col-xs-12'>
                        <ct.TextBox id={`${variant.key}_description`} labelKey='ProductVariant:description' value={description} callback={val => this.setState(s => ({ description: val ? validateVariantDescription(val, []) : s.description }))} />
                    </div>
                    <div className='col-xs-4 col-md-4 col-lg-4'>
                        <ct.DatePicker id={`${variant.key}_availableFrom`} labelKey='ProductVariant:availableFrom' value={availableFrom} callback={val => this.setState(s => ({ availableFrom: val ? validateVariantAvailableFrom(val, []) : s.availableFrom }))} dateFormat={dateFormat} timeFormat={undefined} />
                    </div>
                    <div className='col-xs-4 col-md-4 col-lg-4'>
                        <ct.DatePicker id={`${variant.key}_availableTo`} labelKey='ProductVariant:availableTo' value={availableTo} callback={val => this.setState({ availableTo: validateVariantAvailableTo(val, []) })} dateFormat={dateFormat} timeFormat={undefined} />
                    </div>
                    <div className='col-xs-12'>
                        <label>{t('ProductVariant:productVariantImage')}</label>
                        <div>
                            <Dropzone multiple={false} accept={{ 'image/*': ['.png', '.gif', '.jpeg', '.jpg'] }} onDrop={this.onImageDrop}>
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()} className='file-drop'>
                                        <input {...getInputProps()} />
                                        <p>{t('Global:imageDropText')}</p>
                                    </div>
                                )}
                            </Dropzone>
                            {previewImg}
                            {isNullOrEmpty(imageError) ? null : <div className='alert alert-danger'>{imageError}</div>}
                        </div>
                    </div>
                </div>
                <div className='btn-toolbar' style={({ marginTop: '20px' })}>
                    <button className='btn btn-primary' onClick={e => clickHandler(e, this.save)}>{t('Global:save')}</button>
                    <button className='btn btn-basic' onClick={e => clickHandler(e, close)}>{t('Global:cancel')}</button>
                </div>
            </form>
        </div>
    }
}

export default ProductVariantForm;
